import { render, staticRenderFns } from "./PageServices.vue?vue&type=template&id=07f85270"
import script from "./PageServices.vue?vue&type=script&lang=js"
export * from "./PageServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports